import clsx from 'clsx';
import { TokenIcons } from '../../../assets/icons';
import Card from '../../../components/Card';
import { formatPercentages, formatUSD } from '../../../helpers';
import { UserTotalDeposit } from '../../../hooks/web3/pools/useUserTotalDeposits';

type TotalDepositsProps = {
    lockPoolDetails: UserTotalDeposit['totalDepositsPerPool'][number] & {
        pnl: string;
        pnlPercent: string;
    };
};

const TotalDeposits: React.FC<TotalDepositsProps> = ({ lockPoolDetails }) => {
    const {
        totalLp,
        unlockedTotalLp,
        lockedTotalLp,
        liquidityPool: lockedPool,
        pnl,
        pnlPercent,
    } = lockPoolDetails;

    return (
        <Card className='total-deposits'>
            <div>
                <span className='label'>Pool</span>
                <span>
                    {TokenIcons[lockedPool.lpToken]}
                    {lockedPool.name.split(' ')[0]}
                </span>
            </div>
            <div>
                <span className='label'>Total</span>
                <span>
                    {formatUSD(totalLp, { minDecimals: 2, currency: '' })}{' '}
                    {lockedPool.lpToken}
                </span>
            </div>
            <div>
                <span className='label'>Locked</span>
                <span>
                    {formatUSD(lockedTotalLp, { minDecimals: 2, currency: '' })}{' '}
                    {lockedPool.lpToken}
                </span>
            </div>
            <div>
                <span className='label'>Unlocked</span>
                <span>
                    {formatUSD(unlockedTotalLp, { minDecimals: 2, currency: '' })}{' '}
                    {lockedPool.lpToken}
                </span>
            </div>
            <div>
                <span className='label'>PnL</span>
                <span
                    className={clsx({
                        increased: +pnl > 0,
                        decreased: +pnl < 0,
                    })}
                >
                    {+pnl > 0 && '+'}
                    {formatUSD(pnl, { minDecimals: 2 })} ({formatPercentages(pnlPercent)}
                    %)
                </span>
            </div>
        </Card>
    );
};

export default TotalDeposits;
